import React from "react";
import clsx from "clsx";

import { IRecipientCard } from "./RecipientCard";
import Avatar from "../Avatar";
import Typograpy from "../Typography";
import Button from "../Button";
import { EyeIcon } from "../../../assets/Icons";
import { useNavigate } from "react-router-dom";

const RecipientCard: React.FunctionComponent<IRecipientCard.IProps> = ({
  firstName,
  // lastName,
  accNo,
  onButtonClick,
  cardContainerClassname,
  icon,
  id,
  name,
  bankAccountCountry,
  acNumber,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={clsx(
        "p-3 hover:bg-blue-100 bg-white my-5 w-full flex justify-center items-center rounded-[6px] transition-all shadow-xl",
        cardContainerClassname
      )}
    >
      {/* <Avatar
        textClassname="!text-[24px] md:text-[34px]"
        customClassname="w-[54px] h-[54px]  md:w-[74px] md:h-[74px]"
        name={`${firstName.charAt(0)}`}
      /> */}
      <div className="flex flex-row items-center gap-56 flex-1">
        <Typograpy tagType="span" className="text-xl" text={`${firstName}`} />
        <Typograpy tagType="span" className="text-xl">
          {bankAccountCountry}
        </Typograpy>
        <div className="flex gap-1">
          <Typograpy tagType="span" className="text-xl font-bold">
            A/C No.
          </Typograpy>
          <Typograpy tagType="span" className="text-xl">
            {accNo}
          </Typograpy>
        </div>
      </div>
      <div
        onClick={() => {
          localStorage.setItem("recipient_id", id);
          localStorage.setItem("recipientName", name);
          localStorage.setItem("AcNumber", acNumber);
          navigate("/recipient-profile", { state: { userID: id } });
        }}
        className="mr-[3.75rem] transition-all cursor-pointer hover:scale-125"
      >
        <EyeIcon />
      </div>
      <Button
        className="recipient-button p-2 rounded-md bg-[#006EFF] text-white-100 hover:scale-105 transition-all"
        onClickHandler={() => {
          localStorage.setItem("recipient_id", id);
          localStorage.setItem("recipientName", name);
          localStorage.setItem("AcNumber", acNumber);
          onButtonClick();
        }}
      >
        Select Recipient
      </Button>
    </div>
  );
};

export default RecipientCard;
